import {useCallback, useState} from "react";
import OneSelectUI from "../inputs/one-select";
import '../../styles/elements/check_list.scss'
import CheckElement from "./checkElement";
import {json} from "react-router-dom";
import SubmitButton from "../inputs/SubmitButton";
import {ReactComponent as EditSVG} from "../../assets/edit.svg";
import Popup from "../popup";
import DefaultInput from "../inputs/DefaultInput";

export default function CheckListElement(
  {checkList, setCheckList, categoriesList, selectedCategory, setSelectedCategory, editCategoryFunc, addCategoryFunc, deleteCategoryFunc, saveFunc, saveDisabledFlag, availableB24Fields}
) {


  const deleteCheckElement = useCallback((id) => {
    setCheckList(checkList.filter(el => el.id !== id))
  }, [checkList])

  const [editPopupOpenedFlag, setEditPopupOpenedFlag] = useState()
  const [createPopupOpenedFlag, setCreatePopupOpenedFlag] = useState()

  const [currentCategoryName, setCurrentCategoryName] = useState()
  const [currentCategoryTrigger, setCurrentCategoryTrigger] = useState()

  return (
    <div className={'check_list_editor'}>
      <Popup openedFlag={editPopupOpenedFlag} setOpenedFlag={setEditPopupOpenedFlag} canBeClosedFlag={true}>
        <div className={'edit_check_category_popup'}>
          <DefaultInput
            title={'Название категории'}
            value={currentCategoryName}
            onChangeFunction={e => setCurrentCategoryName(e.target.value)}
          />
          <div className={'textarea-input'}>
            <p>Укажите триггер для использования категории агентом</p>
            <textarea
              className={'edit_check_category_trigger_description'}
              value={currentCategoryTrigger}
              onChange={e => setCurrentCategoryTrigger(e.target.value)}
            />
          </div>
          <div className={'edit-buttons'}>
            <SubmitButton
              className={'delete-button'}
              text={'Удалить'}
              onClick={() => {
                deleteCategoryFunc(selectedCategory.id)
                setEditPopupOpenedFlag(false)
              }}
            />
            <SubmitButton
              text={'Сохранить'}
              onClick={() => {
                editCategoryFunc(selectedCategory.id, {
                  name: currentCategoryName,
                  trigger_description: currentCategoryTrigger
                })
                setEditPopupOpenedFlag(false)
              }}
            />
          </div>
        </div>
      </Popup>
      <Popup openedFlag={createPopupOpenedFlag} setOpenedFlag={setCreatePopupOpenedFlag} canBeClosedFlag={true}>
        <div className={'edit_check_category_popup'}>
          <DefaultInput
            title={'Название для новой категории'}
            value={currentCategoryName}
            onChangeFunction={e => setCurrentCategoryName(e.target.value)}
          />
          <div className={'textarea-input'}>
            <p>Укажите триггер для использования категории агентом</p>
            <textarea
              className={'edit_check_category_trigger_description'}
              value={currentCategoryTrigger}
              onChange={e => setCurrentCategoryTrigger(e.target.value)}
            />
          </div>
          <SubmitButton
            text={'Создать'}
            onClick={() => {
              addCategoryFunc({
                name: currentCategoryName,
                trigger_description: currentCategoryTrigger
              })
              setCreatePopupOpenedFlag(false)
            }}
          />
        </div>
      </Popup>
      <div className={'check_list_header'}>
        <div className={'check_list_header_text'}>Чек лист проверки звонка</div>
        <div className={'check_list_header_buttons'}>
          <OneSelectUI
            selectedOption={selectedCategory ? {label: selectedCategory.name, value: selectedCategory.id} : null}
            setSelectedOption={s => {
              if (!saveDisabledFlag && !window.confirm('Есть несохранённые изменения чек-листа, они будут потеряны. Переключить категорию?')) {
                return
              }
              setSelectedCategory(categoriesList.filter(el => el.id === s.value)[0])
            }}
            selectionOptions={categoriesList.map(el => {return {label: el.name, value: el.id}})}
          />
          <SubmitButton
            onClick={() => {
              if (!selectedCategory) {
                return
              }
              setCurrentCategoryName(selectedCategory.name)
              setCurrentCategoryTrigger(selectedCategory.trigger_description)
              setEditPopupOpenedFlag(true)
            }}
            text={<EditSVG/>}
            className={'add_checklist_button'}
            disabled={!selectedCategory}
          />
          <SubmitButton
            onClick={() => {
              setCurrentCategoryName('')
              setCurrentCategoryTrigger('')
              setCreatePopupOpenedFlag(true)
            }}
            text={'+'}
            className={'add_checklist_button'}
          />
          <SubmitButton
            onClick={saveFunc}
            text={'✔'}
            disabled={saveDisabledFlag}
            className={'save_check_list_button'}
          />
        </div>
      </div>
      <table className={'check_list'}>
        <thead className={'check-list-table-header'}>
        <tr>
          <th>Название</th>
          <th>Описание</th>
          <th>Пример</th>
          <th>Поля в Б24</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td colSpan={5}>
            <SubmitButton
              onClick={() => setCheckList(prev => [
                ...prev,
                {
                  id: `new_${Math.random().toString(36).substr(2, 9)}`,
                  name: '',
                  description: '',
                  example: '',
                  mark_field_system_name: undefined,
                  comment_field_system_name: undefined
                }
              ])}
              text={'Добавить'}
              className={'add_check_el_button'}
            />
          </td>
        </tr>
        {[...checkList].reverse().map((checkEl, i) =>
          <CheckElement
            key={checkEl.id}
            checkEl={checkEl}
            deleteCheckElement={deleteCheckElement}
            availableB24Fields={availableB24Fields}
            setCheckEl={updatedEl => {
              // Обновляем элемент по id
              const newList = checkList.map(el =>
                el.id === updatedEl.id ? updatedEl : el
              );
              setCheckList(newList);
            }}
          />
        )}

        </tbody>
      </table>
    </div>
  )
}